'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetBackerRewardsField } from '@morfi/backend-sdk-v2/client';
import { useLocale, useTranslations } from 'next-intl';
import { OptimizedImage } from '@/components/images/optimized-image';
import { Skeleton } from '@/components/ui/app-skeleton';
import { Link } from '@/i18n/navigation';
import { useFormattedCurrency } from '@/lib/currency';
import { formatBackerVaultShare } from '@/lib/format/backer-vault-share';
import { FEED_CARD_HOVER_BACKGROUND, FEED_CARD_RESTING_OUTLINE } from '@/lib/ui/feed-card-chrome';
import { cn } from '@/lib/ui/utils';
export function BackedProposalRow(t0) {
  const $ = _c(83);
  const {
    pubkey,
    own
  } = t0;
  const t = useTranslations("profile.backedProposals");
  const locale = useLocale();
  const {
    formatD6
  } = useFormattedCurrency();
  const title = useGetBackerRewardsField(pubkey, "marketTitle");
  const image = useGetBackerRewardsField(pubkey, "marketImageUrl");
  const state = useGetBackerRewardsField(pubkey, "marketState");
  const backed = useGetBackerRewardsField(pubkey, "backedD6");
  const total = useGetBackerRewardsField(pubkey, "backedTotalD6");
  const earned = useGetBackerRewardsField(pubkey, "earnedD6");
  const claimed = useGetBackerRewardsField(pubkey, "claimedTotalD6");
  if (backed === undefined || total === undefined || earned === undefined || claimed === undefined || state === undefined) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <Skeleton className="h-24 w-full rounded-card" />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  const href = state === "created" || state === "backing" ? `/proposals/${pubkey}` : `/markets/${pubkey}`;
  const t1 = BigInt(earned);
  const t2 = BigInt(claimed);
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== backed || $[2] !== formatD6 || $[3] !== href || $[4] !== image || $[5] !== locale || $[6] !== own || $[7] !== pubkey || $[8] !== t || $[9] !== t1 || $[10] !== t2 || $[11] !== title || $[12] !== total) {
    const lifetimeEarned = (t1 + t2).toString();
    T0 = Link;
    t8 = href;
    t9 = false;
    t10 = "backed-proposal-row";
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = cn("grid grid-cols-3 items-center gap-4 rounded-card bg-background-primary p-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-border-primary lg:grid-cols-[minmax(0,1fr)_8rem_8rem_8rem] lg:gap-6", FEED_CARD_HOVER_BACKGROUND, FEED_CARD_RESTING_OUTLINE);
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    const t15 = image ?? null;
    let t16;
    if ($[27] !== pubkey || $[28] !== t15) {
      t16 = <OptimizedImage variant="thumbnail" entity={{
        kind: "market",
        pubkey,
        category: "",
        coverImageUrl: t15,
        nsfw: false
      }} alt="" size="size-12" rounded="rounded-control" preview={false} />;
      $[27] = pubkey;
      $[28] = t15;
      $[29] = t16;
    } else {
      t16 = $[29];
    }
    const t17 = title ?? "";
    let t18;
    if ($[30] !== t17) {
      t18 = <h3 className="line-clamp-2 min-w-0 text-body font-medium text-foreground-primary">{t17}</h3>;
      $[30] = t17;
      $[31] = t18;
    } else {
      t18 = $[31];
    }
    if ($[32] !== t16 || $[33] !== t18) {
      t12 = <div className="col-span-3 flex min-w-0 items-center gap-3 lg:col-span-1">{t16}{t18}</div>;
      $[32] = t16;
      $[33] = t18;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    let t19;
    if ($[35] !== own || $[36] !== t) {
      t19 = own ? t("yourBacking") : t("amountBacked");
      $[35] = own;
      $[36] = t;
      $[37] = t19;
    } else {
      t19 = $[37];
    }
    let t20;
    if ($[38] !== t19) {
      t20 = <span className="min-h-8 text-caption text-foreground-tertiary lg:sr-only">{t19}</span>;
      $[38] = t19;
      $[39] = t20;
    } else {
      t20 = $[39];
    }
    let t21;
    if ($[40] !== backed || $[41] !== formatD6) {
      t21 = formatD6(backed, "compactTight");
      $[40] = backed;
      $[41] = formatD6;
      $[42] = t21;
    } else {
      t21 = $[42];
    }
    let t22;
    if ($[43] !== t21) {
      t22 = <span className="text-body font-medium tabular-nums" data-testid="backed-proposal-amount">{t21}</span>;
      $[43] = t21;
      $[44] = t22;
    } else {
      t22 = $[44];
    }
    if ($[45] !== t20 || $[46] !== t22) {
      t13 = <div className="flex min-w-0 flex-col gap-1">{t20}{t22}</div>;
      $[45] = t20;
      $[46] = t22;
      $[47] = t13;
    } else {
      t13 = $[47];
    }
    let t23;
    if ($[48] !== t) {
      t23 = t("vaultShare");
      $[48] = t;
      $[49] = t23;
    } else {
      t23 = $[49];
    }
    let t24;
    if ($[50] !== t23) {
      t24 = <span className="min-h-8 text-caption text-foreground-tertiary lg:sr-only">{t23}</span>;
      $[50] = t23;
      $[51] = t24;
    } else {
      t24 = $[51];
    }
    let t25;
    if ($[52] !== backed || $[53] !== locale || $[54] !== total) {
      t25 = formatBackerVaultShare(backed, total, locale);
      $[52] = backed;
      $[53] = locale;
      $[54] = total;
      $[55] = t25;
    } else {
      t25 = $[55];
    }
    let t26;
    if ($[56] !== t25) {
      t26 = <span className="text-body tabular-nums" data-testid="backed-proposal-share">{t25}</span>;
      $[56] = t25;
      $[57] = t26;
    } else {
      t26 = $[57];
    }
    if ($[58] !== t24 || $[59] !== t26) {
      t14 = <div className="flex min-w-0 flex-col gap-1">{t24}{t26}</div>;
      $[58] = t24;
      $[59] = t26;
      $[60] = t14;
    } else {
      t14 = $[60];
    }
    t6 = "flex min-w-0 flex-col gap-1";
    let t27;
    if ($[61] !== t) {
      t27 = t("earned");
      $[61] = t;
      $[62] = t27;
    } else {
      t27 = $[62];
    }
    if ($[63] !== t27) {
      t7 = <span className="min-h-8 text-caption text-foreground-tertiary lg:sr-only">{t27}</span>;
      $[63] = t27;
      $[64] = t7;
    } else {
      t7 = $[64];
    }
    t3 = "text-body font-medium tabular-nums text-feedback-success-content";
    t4 = "backed-proposal-earned";
    t5 = formatD6(lifetimeEarned, "compactTight");
    $[1] = backed;
    $[2] = formatD6;
    $[3] = href;
    $[4] = image;
    $[5] = locale;
    $[6] = own;
    $[7] = pubkey;
    $[8] = t;
    $[9] = t1;
    $[10] = t2;
    $[11] = title;
    $[12] = total;
    $[13] = T0;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    T0 = $[13];
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
    t13 = $[17];
    t14 = $[18];
    t3 = $[19];
    t4 = $[20];
    t5 = $[21];
    t6 = $[22];
    t7 = $[23];
    t8 = $[24];
    t9 = $[25];
  }
  let t15;
  if ($[65] !== t3 || $[66] !== t4 || $[67] !== t5) {
    t15 = <span className={t3} data-testid={t4}>{t5}</span>;
    $[65] = t3;
    $[66] = t4;
    $[67] = t5;
    $[68] = t15;
  } else {
    t15 = $[68];
  }
  let t16;
  if ($[69] !== t15 || $[70] !== t6 || $[71] !== t7) {
    t16 = <div className={t6}>{t7}{t15}</div>;
    $[69] = t15;
    $[70] = t6;
    $[71] = t7;
    $[72] = t16;
  } else {
    t16 = $[72];
  }
  let t17;
  if ($[73] !== T0 || $[74] !== t10 || $[75] !== t11 || $[76] !== t12 || $[77] !== t13 || $[78] !== t14 || $[79] !== t16 || $[80] !== t8 || $[81] !== t9) {
    t17 = <T0 href={t8} prefetch={t9} data-testid={t10} className={t11}>{t12}{t13}{t14}{t16}</T0>;
    $[73] = T0;
    $[74] = t10;
    $[75] = t11;
    $[76] = t12;
    $[77] = t13;
    $[78] = t14;
    $[79] = t16;
    $[80] = t8;
    $[81] = t9;
    $[82] = t17;
  } else {
    t17 = $[82];
  }
  return t17;
}